export const STREAMING_GAMETYPE_OPTIONS = [
  { text: 'All', value: 'all' },
  { text: 'Mobile & PC or Console', value: 'mobile&pcOrConsole' },
  { text: 'PC & Console', value: 'pc&console' },
  { text: 'Mobile Only', value: 'mobileOnly' },
];
export const COMPETITOR_PLATFORM_OPTIONS = [
  { text: 'PC', value: 'pc' },
  { text: 'Console', value: 'console' },
];
